export const loginRoute = {
  path: "/login",
  component: () => import("@/views/login/index.vue"),
};
